var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3687_8464",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3687_8464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.06634 9.20065L5.61634 7.75065C5.49412 7.62843 5.34145 7.57021 5.15834 7.57598C4.97479 7.58132 4.8219 7.6451 4.69967 7.76732C4.57745 7.88954 4.51634 8.0451 4.51634 8.23398C4.51634 8.42287 4.57745 8.57843 4.69967 8.70065L6.59967 10.6007C6.7219 10.7229 6.87745 10.784 7.06634 10.784C7.25523 10.784 7.41079 10.7229 7.53301 10.6007L11.3163 6.81732C11.4386 6.6951 11.497 6.54221 11.4917 6.35865C11.4859 6.17554 11.4219 6.02287 11.2997 5.90065C11.1775 5.77843 11.0219 5.71732 10.833 5.71732C10.6441 5.71732 10.4886 5.77843 10.3663 5.90065L7.06634 9.20065ZM7.99967 14.6673C7.07745 14.6673 6.21079 14.4922 5.39967 14.142C4.58856 13.7922 3.88301 13.3173 3.28301 12.7173C2.68301 12.1173 2.20812 11.4118 1.85834 10.6007C1.50812 9.78954 1.33301 8.92287 1.33301 8.00065C1.33301 7.07843 1.50812 6.21176 1.85834 5.40065C2.20812 4.58954 2.68301 3.88398 3.28301 3.28398C3.88301 2.68398 4.58856 2.20887 5.39967 1.85865C6.21079 1.50887 7.07745 1.33398 7.99967 1.33398C8.9219 1.33398 9.78856 1.50887 10.5997 1.85865C11.4108 2.20887 12.1163 2.68398 12.7163 3.28398C13.3163 3.88398 13.7912 4.58954 14.141 5.40065C14.4912 6.21176 14.6663 7.07843 14.6663 8.00065C14.6663 8.92287 14.4912 9.78954 14.141 10.6007C13.7912 11.4118 13.3163 12.1173 12.7163 12.7173C12.1163 13.3173 11.4108 13.7922 10.5997 14.142C9.78856 14.4922 8.9219 14.6673 7.99967 14.6673ZM7.99967 13.334C9.47745 13.334 10.7359 12.8147 11.775 11.776C12.8137 10.7369 13.333 9.47843 13.333 8.00065C13.333 6.52287 12.8137 5.26443 11.775 4.22532C10.7359 3.18665 9.47745 2.66732 7.99967 2.66732C6.5219 2.66732 5.26367 3.18665 4.22501 4.22532C3.1859 5.26443 2.66634 6.52287 2.66634 8.00065C2.66634 9.47843 3.1859 10.7369 4.22501 11.776C5.26367 12.8147 6.5219 13.334 7.99967 13.334Z",
    fill: "black",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSvg);
export default __webpack_public_path__ + "static/media/checkSvg.a1c1d763.svg";
export { ForwardRef as ReactComponent };